import React, {useState} from 'react'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faInfo} from '@fortawesome/free-solid-svg-icons';
import getCookie from '../../../../partials/cookie';
import {Errors} from '../../../../partials/Partials';

function Password() {
    const [show, setShow] = useState(false)
    const [show_success, setSuccess] = useState(false);
    const [password_type, setPasswordType] = useState(true);
    const [errors, setErrors] = useState([])

    const submitPassword = (e) => {
        const csrftoken = getCookie('csrftoken');
        e.preventDefault();
        const old_password = e.target.querySelector('#old_password').value
        const new_password1 = e.target.querySelector('#new_password1').value
        const new_password2 = e.target.querySelector('#new_password2').value
        console.log(e.target.querySelector('#old_password').value)
        fetch('/api/lawyer_profiles_extended/current/set_password/', {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                old_password: old_password,
                new_password1: new_password1,
                new_password2: new_password2
            })
        }).then(res => {
            if (res.ok) {
                setSuccess(true)
                setShow(false)
                setErrors([])
            } else {
                res.json().then(data => {
                    let errors_list = []
                    if (Object.values(data).length > 0) {
                        Object.values(data).forEach(value => {
                            errors_list.push(...value);
                        })
                    }
                    setErrors(errors_list)
                })
            }
        })
    }
    return (
        <div id="password">
            {show_success ? 
                <div className="alert alert-success">Hasło zostało zmienione</div>
                :
                null
            }
            <h1 className="title">Hasło</h1>
            <button className="btn btn-primary" onClick={() => setShow(!show)}>Zmień hasło</button>
            <Modal show={show}  onHide={() => {setShow(false); setErrors([])}} id="password-modal-whole">
                <Modal.Header closeButton >
                    <Modal.Title>
                        <FontAwesomeIcon icon={faInfo} className='fa-info'/>
                        Zmiana hasła
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div id="password-modal" className='row'> 
                        <Errors errors={errors} />
                        <form onSubmit={(e) => submitPassword(e)}>
                            <div className="form-group">
                                <p>Twoje hasło <span>(wprowadź, aby mieć możliwość poprawiania danych w przyszłości)</span></p>
                                <input id="old_password"type={password_type ? 'password' : 'text'} />
                            </div>
                            <div className="form-group">
                                <p>Nowe hasło</p>
                                <input id="new_password1"type={password_type ? 'password' : 'text'}  />
                            </div>
                            <div className="form-group">
                                <p>Powtórz nowe hasło</p>
                                <input id="new_password2"type={password_type ? 'password' : 'text'}  />
                            </div>
                            <div className="row">
                                <span onClick={() => setPasswordType(!password_type)} className="alike">{password_type ? 'Pokaż mi co napisałem' : 'Ukryj to, co napisałem'}</span>
                                <div className="inline">
                                    <button className="btn btn-default" type="button"onClick={() => {setShow(false); setErrors([])}}>Zamknij</button>
                                    <button className="btn btn-primary" type="submit">Zapisz</button>
                                </div> 
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Password